export const RefundConstant = {
    SEARCH_CRITERIA: "Search Criteria",
    CREATED_DATE_RANGE: "Created Date Range",
    CATEGORY: "Payment",
    TITLE: "Refund",
    RECEIPT_NO: "Receipt No.",
    REFUND_DRAFT_ID: "Refund Draft ID",
    REFUND_FINAL_ID: "Refund Final ID",
    COUNTER_CUSTOMER_ID: "Counter Customer ID",
    PAYEE_NAME: "Payee Name",
    PAYEE_NTN: "Payee NTN",
    PAYMENT_AMOUNT: "Payment Amount",
    PAIED_INVOICE_AMOUNT: "Paid Invoice Amount",
    TOTAL_INVOICE_AMOUNT: "Total Invoice Amount",
    HANDLING_CHARGE: "Handling Charge",
    REFUND_AMOUNT: "Refund Amount",
    CHEQUE_COLLECTOR_NAME: "Cheque Collector Name",
    CNIC: "CNIC",
    MOBILE_NO: "Mobile No.",
    CHEQUE_NO: "Cheque No.",
    CHEQUE_ISSUE_DATE: "Cheque Issue Date",
    CHEQUE_AMOUNT: "Cheque Amount",
    CREATED_BY: "Created By",
    CREATED_DATE: "Created Date",
    CHANGED_BY: "Changed By",
    CHANGED_DATE: "Changed Date",
    VERIFIED_BY: "Verified By",
    VERIFIED_DATE: "Verified Date",
    APPROVED_BY: "Approved By",
    APPROVED_DATE: "Approved Date",
    REFUNDED_BY: "Refunded By",
    REFUNDED_DATE: "Refunded Date",
    PROCESSED_BY: "Processed By",
    PROCESSED_DATE: "Processed Date",
    ISSUED_BY: "Issued By",
    ISSUED_DATE: "Issued Date",
    REFUND_TYPE: "Refund Type",
    STATUS: "Status",
    REMARK: "Remark",
    PAY_ORDER_NO: "Pay Order No.",
    BANK_CODE: "Bank Code",
    AGENT_NAME: "Agent Name",
    REJECT_CODE: "Reject Code",
}
export const RefundRequiredFieldList: string[] = [
    'companyCode',
    'paymentMode',
    'bankCode',
    'payOrderNo',
    'transactionAmount',
    'activeInd',
];

export const RefundPermissionCodePolicy = {

    REFUND_BUTTON_VERIFY: 'verify',
    REFUND_BUTTON_PROCESS: 'process',
    REFUND_BUTTON_ISSUE: 'issue',
    REFUND_BUTTON_APPROVE: 'approve',
    REFUND_BUTTON_REJECT: 'reject',
}